import type { Template } from "@/types";

export const PO_06_H3_V3: Template[] = [
    {
        id: "po-06-h3v3-01",
        name: "PO 01 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 49, y: 193, width: 258, height: 171, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 372, width: 258, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 49, y: 551, width: 258, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 315, y: 193, width: 352, height: 529, rotation: 0, imageRotation: 0 },
            { id: "5", x: 709, y: 228, width: 307, height: 460, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 228, width: 307, height: 460, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-02",
        name: "PO 02 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 162, width: 391, height: 593, rotation: 0, imageRotation: 0 },
            { id: "2", x: 446, y: 162, width: 195, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 446, y: 463, width: 195, height: 292, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 162, width: 593, height: 395, rotation: 0, imageRotation: 0 },
            { id: "5", x: 734, y: 564, width: 293, height: 191, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 564, width: 292, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-03",
        name: "PO 03 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 162, width: 593, height: 395, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 564, width: 293, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 564, width: 292, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 735, y: 162, width: 391, height: 593, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1133, y: 162, width: 195, height: 293, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 463, width: 195, height: 292, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-04",
        name: "PO 04 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 49, y: 148, width: 619, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 568, width: 306, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 568, width: 305, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 761, y: 199, width: 338, height: 518, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1107, y: 199, width: 171, height: 256, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1107, y: 463, width: 171, height: 254, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-05",
        name: "PO 05 - H3V3",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 58, y: 87, width: 359, height: 242, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 337, width: 359, height: 241, rotation: 0, imageRotation: 0 },
            { id: "3", x: 58, y: 586, width: 359, height: 241, rotation: 0, imageRotation: 0 },
            { id: "4", x: 425, y: 87, width: 497, height: 740, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1070, y: 87, width: 243, height: 366, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1070, y: 461, width: 243, height: 366, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-06",
        name: "PO 06 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 69, y: 171, width: 441, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 462, width: 441, height: 283, rotation: 0, imageRotation: 0 },
            { id: "3", x: 518, y: 171, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 518, y: 365, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 518, y: 559, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 742, y: 265, width: 578, height: 385, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-07",
        name: "PO 07 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 69, y: 171, width: 286, height: 438, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 617, width: 188, height: 128, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 171, width: 285, height: 438, rotation: 0, imageRotation: 0 },
            { id: "4", x: 265, y: 617, width: 188, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 461, y: 617, width: 187, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 838, y: 171, width: 385, height: 574, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h3v3-08",
        name: "PO 08 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 46, y: 206, width: 350, height: 503, rotation: 0, imageRotation: 0 },
            { id: "2", x: 404, y: 206, width: 350, height: 503, rotation: 0, imageRotation: 0 },
            { id: "3", x: 762, y: 206, width: 349, height: 503, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1119, y: 206, width: 210, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1119, y: 377, width: 210, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1119, y: 547, width: 210, height: 162, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-09",
        name: "PO 09 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 52, y: 262, width: 127, height: 192, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 461, width: 286, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 187, y: 262, width: 286, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 346, y: 461, width: 127, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 481, y: 262, width: 582, height: 391, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1071, y: 262, width: 252, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-10",
        name: "PO 10 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 249, width: 140, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 462, width: 140, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 148, y: 249, width: 624, height: 418, rotation: 0, imageRotation: 0 },
            { id: "4", x: 780, y: 249, width: 285, height: 418, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1073, y: 249, width: 300, height: 205, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1073, y: 462, width: 300, height: 205, rotation: 0, imageRotation: 0 }
        ],
    },
];

